<template>
    <div class="main-menu menu-fixed menu-accordion menu-shadow menu-light">
        <vertical-nav-menu-items :items="navMenuItems" class="navigation navigation-main" />
    </div>
</template>

<script>
import VerticalNavMenuItems from './vertical-nav-menu-items.vue';

export default {
    components: { VerticalNavMenuItems },
    props: {
        metadata: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            navMenuItems: [
                {
                    title: 'Setup',
                    tab: 'setup',
                    icon: ['fas', 'gear'],
                },
                {
                    title: 'Door Locks',
                    tab: 'door-locks',
                    icon: ['fas', 'lock'],
                    hide: !this.metadata.has_door_locks || !this.metadata.permissions.door_locks_view,
                },
                {
                    title: 'Guests',
                    tab: 'guests',
                    icon: ['fas', 'users'],
                },
                {
                    title: 'Correspondence',
                    tab: 'correspondence',
                    icon: ['fas', 'inbox'],
                    hide: !this.metadata.permissions.email_view,
                },
                {
                    title: 'Triggers',
                    tab: 'triggers',
                    icon: ['fas', 'bolt-lightning'],
                    hide: !this.metadata.permissions.email_view,
                },
                {
                    title: 'Billing',
                    tab: 'billing',
                    icon: ['far', 'credit-card'],
                    hide: !this.metadata.subscriber.has_cc_gateway || !this.metadata.permissions.billing_view,
                },
                {
                    title: 'Transactions',
                    tab: 'transactions',
                    icon: ['fas', 'right-left'],
                    hide: !this.metadata.permissions.transactions_view,
                },
                {
                    title: 'Documents',
                    tab: 'documents',
                    icon: ['fas', 'file-lines'],
                },
                {
                    title: 'Commissions',
                    tab: 'commissions',
                    icon: ['fas', 'chart-pie'],
                    hide: !this.metadata.has_property_management_module,
                },
                {
                    title: 'Housekeeping',
                    tab: 'housekeeping',
                    icon: ['far', 'note-sticky'],
                },
                {
                    title: 'History',
                    tab: 'history',
                    icon: ['far', 'calendar-days'],
                },
                {
                    title: 'Custom',
                    tab: 'custom',
                    icon: ['fas', 'gear'],
                },
            ],
        };
    },
};
</script>

<style lang="scss">
@import '../../../../../scss/bootstrap-extended/menu-types/vertical-menu.scss';
.navigation {
    font-family: inherit !important;
}
</style>
